import React from "react";
import { ArrowRight } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { formatCompact, runwayFull } from "@/lib/currency";
import { cn } from "@/lib/utils";

function Line({ label, value, accent }) {
  return (
    <div className="flex items-center justify-between py-1.5">
      <span className="text-xs text-zinc-500">{label}</span>
      <span className={cn("font-mono text-sm font-semibold", accent || "text-zinc-800")}>
        {value}
      </span>
    </div>
  );
}

// before/after are metrics objects from calculations.metricsFrom
export function BeforeAfter({ before, after, testId }) {
  const afterBalanceLabel = after.isPositive ? "Sisa Bulanan" : "Defisit Bulanan";
  const afterBalanceValue = after.isPositive
    ? formatCompact(after.monthlyBalance)
    : "-" + formatCompact(after.monthlyDeficit).replace("Rp", "Rp");

  return (
    <div className="grid grid-cols-1 gap-3" data-testid={testId}>
      <div className="rounded-2xl border border-zinc-200 bg-white p-4">
        <div className="mb-2 flex items-center justify-between">
          <span className="text-xs font-semibold uppercase tracking-wider text-zinc-400 font-heading">
            Sebelum
          </span>
          <StatusBadge status={before.status} />
        </div>
        <Line label="Pendapatan" value={formatCompact(before.totalFamilyIncome)} />
        <Line label="Pengeluaran Wajib" value={formatCompact(before.essentialOutflow)} />
        <Line
          label={before.isPositive ? "Sisa Bulanan" : "Defisit Bulanan"}
          value={
            before.isPositive
              ? formatCompact(before.monthlyBalance)
              : "-" + formatCompact(before.monthlyDeficit)
          }
          accent={before.isPositive ? "text-emerald-600" : "text-rose-600"}
        />
        <Line label="Dana Darurat" value={formatCompact(before.emergency)} />
      </div>

      <div className="flex items-center justify-center">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-zinc-900 text-white">
          <ArrowRight className="h-4 w-4 rotate-90" />
        </div>
      </div>

      <div className="rounded-2xl border border-zinc-200 bg-white p-4">
        <div className="mb-2 flex items-center justify-between">
          <span className="text-xs font-semibold uppercase tracking-wider text-zinc-400 font-heading">
            Setelah
          </span>
          <StatusBadge status={after.status} />
        </div>
        <Line label="Pendapatan" value={formatCompact(after.totalFamilyIncome)} />
        <Line label="Pengeluaran Wajib" value={formatCompact(after.essentialOutflow)} />
        <Line
          label={afterBalanceLabel}
          value={afterBalanceValue}
          accent={after.isPositive ? "text-emerald-600" : "text-rose-600"}
        />
        {after.isPositive ? (
          <Line label="Cashflow" value="Tetap positif" accent="text-emerald-600" />
        ) : (
          <>
            <Line
              label="Survival Runway"
              value={runwayFull(after.survivalRunway)}
              accent="text-zinc-900"
            />
            <p className="mt-1 rounded-lg bg-zinc-50 px-2.5 py-1.5 font-mono text-[10px] text-zinc-500">
              Dana Darurat {formatCompact(after.emergency)} ÷ Defisit{" "}
              {formatCompact(after.monthlyDeficit)}/bln = {runwayFull(after.survivalRunway)}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
